import { get, post } from '@/request/request';

export default {
  list(params) {
    return get('/admin/doc/employee/list', params);
  },
  info(params) {
    return get('/admin/doc/employee/info', params);
  },
  save(params) {
    return post('/admin/doc/employee/save', params);
  },
  delete(params) {
    return post('/admin/doc/employee/delete', params);
  }
};
